module.exports = __webpack_public_path__ + "static/media/minus.49f7d781.svg";